import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';
import baJSON from './translations/ba';
import enJSON from './translations/en';

const resources = {
  ba: { translation: baJSON },
  en: { translation: enJSON }
};

i18n.use(initReactI18next).init({
  resources,
  keySeparator: false,
  lng: 'ba',
  fallbackLng: 'ba',
  react: {
    useSuspense: true
  },
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
